import { CommandConfig } from '../../CommandConfig';

export default {
  command: 'test',
  description: 'Run tests using Jest',
  options: [],
} as CommandConfig;
